var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLgBrandLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0836182 5.72141C0.319225 6.66292 1.05242 7.14805 2.28247 7.14805H32.6802C34.1456 7.14805 34.9613 6.40608 34.9613 4.97649V2.64593C34.9613 1.21634 34.1456 0.474365 32.6802 0.474365H2.28247C1.05242 0.474365 0.319225 0.959491 0.0836182 1.90101V5.72141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7451 25.552C78.2105 25.552 79.0262 26.294 79.0262 27.7236V30.0541C79.0262 31.4837 78.2105 32.2257 76.7451 32.2257H42.7235C41.2023 32.2257 40.4424 31.4837 40.4424 30.0541V27.7236C40.4424 26.294 41.2023 25.552 42.7235 25.552H76.7451Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4579 13.001C61.9248 13.001 62.7404 13.7429 62.7404 15.1725V17.5031C62.7404 18.9327 61.9248 19.6733 60.4579 19.6733H42.7416C41.2204 19.6733 40.4591 18.9327 40.4591 17.5031V15.1725C40.4591 13.7429 41.2204 13.001 42.7416 13.001H60.4579Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7192 13.0471C34.186 13.0471 35.0017 13.7877 35.0017 15.2173V17.5479C35.0017 18.9775 34.186 19.7181 32.7192 19.7181H25.8716C24.3504 19.7181 23.5891 18.9775 23.5891 17.5479V15.2173C23.5891 13.7877 24.3504 13.0471 25.8716 13.0471H32.7192Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgBrandLogo);
export default __webpack_public_path__ + "static/media/lg_brand-logo.8b56038279875dbcc7d3451b718ef0ad.svg";
export { ForwardRef as ReactComponent };